export const templateFn = function anonymous(locals, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<% if (!$ctrl.notificationsLoaded) { %>\n  <div class=\"nb-menu-body\">\n    <div class=\"nb-notifications-list\">\n      <svg class=\"nb-spinner\" aria-label=\"<% t('SPINNER.loading')%>\">\n        <title><% t('SPINNER.loading')%></title>\n        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg-spinner\"></use>\n      </svg>\n    </div>\n  </div>\n<% } else if (!$ctrl.notifications.length) { %>\n  <div class=\"nb-menu-body\">\n    <div class=\"nb-notifications-list\">\n      <div class=\"nb-menu-empty-state\">\n        <h2 class=\"nb-menu-empty-state__main\"><%= t('NOTIFICATIONS.empty_title') %></h2>\n        <p class=\"nb-menu-empty-state__sub\"><%= t('NOTIFICATIONS.empty_description') %></p>\n      </div>\n    </div>\n  </div>\n<% } else { %>\n  <div class=\"nb-menu-body\" role=\"list\">\n    <div class=\"nb-notifications-list\">\n      <% $ctrl.notifications.forEach(function(notification) { %>\n        <div\n          class=\"nb-notifications-list__item nb-notifications-list__item--view\"\n          data-notification-type=\"<%= notification.notification_type %>\"\n          data-notification-id=\"<%= notification.id %>\"\n          data-notification-uuid=\"<%= notification.uuid %>\"\n          data-notification-originator-id=\"<%= notification.originator_id %>\"\n          data-notification-activation-code=\"<%= notification.activation_code %>\"\n          role=\"listitem\"\n          aria-labelledby=\"notification-id-<%= notification.id %>\">\n          <div class=\"nb-notification-view\">\n            <span\n              aria-hidden=\"true\"\n              class=\"nb-simple-avatar nb-simple-avatar--<%= notification.subject_avatar ? 'image' : 'initials' %>\"\n                <% if (notification.subject_avatar) { %>\n                  style=\"background-image: url('<%= notification.subject_avatar %>');\"\n                <% } %>\n              >\n              <div class=\"nb-simple-avatar__invite-badge-container\">\n                <%- $ctrl.inviteBadges[notification.notification_type] %>\n              </div>\n              <span class=\"nb-menu__profile-initials\">\n                <%= initialsFromFullName(notification.persona.name) %>\n              </span>\n            </span>\n            <span class=\"nb-notification-summary\">\n              <div class=\"nb-notification-summary__info\" id=\"notification-id-<%= notification.id %>\">\n                <%- $ctrl.buildPhrase(notification) %>\n              </div>\n              <div class=\"nb-notification-summary__date\">\n                <%= formatDate(notification.updated_at) %>\n              </div>\n              <div class=\"nb-notification-summary__actions\">\n                <% if (notification.notification_type === 'guardian_invite') { %>\n                  <button type=\"button\" class=\"nb-notification-summary__action\" data-notification-method=\"accept\" nb-event=\"Notification:Click:Accept\">\n                    Accept\n                  </button>\n                <% } else { %>\n                  <a href=\"<%= $ctrl.buildAcceptUrl(notification) %>\" class=\"nb-notification-summary__action\" data-notification-method=\"accept\" nb-event=\"Notification:Click:Accept\">\n                    Accept\n                  </a>\n                <% } %>\n                |\n                <button type=\"button\" class=\"nb-notification-summary__action\" data-notification-method=\"decline\" nb-event=\"Notification:Click:Decline\">Decline</button>\n              </div>\n            </span>\n          </div>\n          <div class=\"nb-notification-action-progress\">\n            <div class=\"nb-notification-action-progress__message-container\">\n              <span class=\"nb-notification-action-progress__message\"> In Progress </span>\n              <button type=\"button\" class=\"nb-button nb-notification-action-progress__retry-button\" data-notification-method=\"retry\" nb-event=\"Notification:Click:Retry\"> Try Again </button>\n            </div>\n            <div class=\"nb-progress-bar\">\n              <span class=\"nb-progress-bar__progress\"></span>\n            </div>\n          </div>\n        </div>\n      <% }) %>\n    </div>\n  </div>\n<% } %>\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
$ctrl = __locals.$ctrl,
  config = __locals.config,
  formatDate = __locals.formatDate,
  hasTouch = __locals.hasTouch,
  initializeCSSVars = __locals.initializeCSSVars,
  initialsFromFullName = __locals.initialsFromFullName,
  multiToggleFactory = __locals.multiToggleFactory,
  t = __locals.t,
  htmlWebpackPlugin = __locals.htmlWebpackPlugin;
    ;  if (!$ctrl.notificationsLoaded) { 
    ; __append("\n  <div class=\"nb-menu-body\">\n    <div class=\"nb-notifications-list\">\n      <svg class=\"nb-spinner\" aria-label=\"")
    ; __line = 4
    ;  t('SPINNER.loading')
    ; __append("\">\n        <title>")
    ; __line = 5
    ;  t('SPINNER.loading')
    ; __append("</title>\n        <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg-spinner\"></use>\n      </svg>\n    </div>\n  </div>\n")
    ; __line = 10
    ;  } else if (!$ctrl.notifications.length) { 
    ; __append("\n  <div class=\"nb-menu-body\">\n    <div class=\"nb-notifications-list\">\n      <div class=\"nb-menu-empty-state\">\n        <h2 class=\"nb-menu-empty-state__main\">")
    ; __line = 14
    ; __append(escapeFn( t('NOTIFICATIONS.empty_title') ))
    ; __append("</h2>\n        <p class=\"nb-menu-empty-state__sub\">")
    ; __line = 15
    ; __append(escapeFn( t('NOTIFICATIONS.empty_description') ))
    ; __append("</p>\n      </div>\n    </div>\n  </div>\n")
    ; __line = 19
    ;  } else { 
    ; __append("\n  <div class=\"nb-menu-body\" role=\"list\">\n    <div class=\"nb-notifications-list\">\n      ")
    ; __line = 22
    ;  $ctrl.notifications.forEach(function(notification) { 
    ; __append("\n        <div\n          class=\"nb-notifications-list__item nb-notifications-list__item--view\"\n          data-notification-type=\"")
    ; __line = 25
    ; __append(escapeFn( notification.notification_type ))
    ; __append("\"\n          data-notification-id=\"")
    ; __line = 26
    ; __append(escapeFn( notification.id ))
    ; __append("\"\n          data-notification-uuid=\"")
    ; __line = 27
    ; __append(escapeFn( notification.uuid ))
    ; __append("\"\n          data-notification-originator-id=\"")
    ; __line = 28
    ; __append(escapeFn( notification.originator_id ))
    ; __append("\"\n          data-notification-activation-code=\"")
    ; __line = 29
    ; __append(escapeFn( notification.activation_code ))
    ; __append("\"\n          role=\"listitem\"\n          aria-labelledby=\"notification-id-")
    ; __line = 31
    ; __append(escapeFn( notification.id ))
    ; __append("\">\n          <div class=\"nb-notification-view\">\n            <span\n              aria-hidden=\"true\"\n              class=\"nb-simple-avatar nb-simple-avatar--")
    ; __line = 35
    ; __append(escapeFn( notification.subject_avatar ? 'image' : 'initials' ))
    ; __append("\"\n                ")
    ; __line = 36
    ;  if (notification.subject_avatar) { 
    ; __append("\n                  style=\"background-image: url('")
    ; __line = 37
    ; __append(escapeFn( notification.subject_avatar ))
    ; __append("');\"\n                ")
    ; __line = 38
    ;  } 
    ; __append("\n              >\n              <div class=\"nb-simple-avatar__invite-badge-container\">\n                ")
    ; __line = 41
    ; __append( $ctrl.inviteBadges[notification.notification_type] )
    ; __append("\n              </div>\n              <span class=\"nb-menu__profile-initials\">\n                ")
    ; __line = 44
    ; __append(escapeFn( initialsFromFullName(notification.persona.name) ))
    ; __append("\n              </span>\n            </span>\n            <span class=\"nb-notification-summary\">\n              <div class=\"nb-notification-summary__info\" id=\"notification-id-")
    ; __line = 48
    ; __append(escapeFn( notification.id ))
    ; __append("\">\n                ")
    ; __line = 49
    ; __append( $ctrl.buildPhrase(notification) )
    ; __append("\n              </div>\n              <div class=\"nb-notification-summary__date\">\n                ")
    ; __line = 52
    ; __append(escapeFn( formatDate(notification.updated_at) ))
    ; __append("\n              </div>\n              <div class=\"nb-notification-summary__actions\">\n                ")
    ; __line = 55
    ;  if (notification.notification_type === 'guardian_invite') { 
    ; __append("\n                  <button type=\"button\" class=\"nb-notification-summary__action\" data-notification-method=\"accept\" nb-event=\"Notification:Click:Accept\">\n                    Accept\n                  </button>\n                ")
    ; __line = 59
    ;  } else { 
    ; __append("\n                  <a href=\"")
    ; __line = 60
    ; __append(escapeFn( $ctrl.buildAcceptUrl(notification) ))
    ; __append("\" class=\"nb-notification-summary__action\" data-notification-method=\"accept\" nb-event=\"Notification:Click:Accept\">\n                    Accept\n                  </a>\n                ")
    ; __line = 63
    ;  } 
    ; __append("\n                |\n                <button type=\"button\" class=\"nb-notification-summary__action\" data-notification-method=\"decline\" nb-event=\"Notification:Click:Decline\">Decline</button>\n              </div>\n            </span>\n          </div>\n          <div class=\"nb-notification-action-progress\">\n            <div class=\"nb-notification-action-progress__message-container\">\n              <span class=\"nb-notification-action-progress__message\"> In Progress </span>\n              <button type=\"button\" class=\"nb-button nb-notification-action-progress__retry-button\" data-notification-method=\"retry\" nb-event=\"Notification:Click:Retry\"> Try Again </button>\n            </div>\n            <div class=\"nb-progress-bar\">\n              <span class=\"nb-progress-bar__progress\"></span>\n            </div>\n          </div>\n        </div>\n      ")
    ; __line = 79
    ;  }) 
    ; __append("\n    </div>\n  </div>\n")
    ; __line = 82
    ;  } 
    ; __append("\n")
    ; __line = 83
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}; export default templateFn